import { signOut } from 'next-auth/react';

export const logout = (redirectTo?: string) => signOut({ redirectTo });
